{{#if isValid}}
    {{#if canUploadFiles}}
        {{#if fileSessionId}}
            <td class="orderItem-files {{#if initialized}}{{#if fileSessionCount}}orderItem-files_hasFiles{{else}}orderItem-files_needFiles{{/if}}{{/if}}">
                {{#if initialized}}
                    {{#if fileSessionCount}}
                        <div class="orderItem-files-counter">{{fileSessionCount}}</div>
                        <button class="orderItem-files-editble js-openFilesModal">Add / Edit<br />File[s]</button>
                    {{else}}
                        <button class="orderItem-files-editble js-openFilesModal">Add File[s]</button>
                    {{/if}}
                {{else}}
                    <div class="requestIsProcessing" style="display: inline-block; position: relative; right: 25px;"></div>
                {{/if}}
                <file-status {{#if fileSessionId}}file-session-id="{{fileSessionId}}"{{else}}order-item-id="{{id}}"{{/if}} id="file-status-{{id}}"></file-status>
            </td>
        {{else}}
            <td class="orderItem-files {{#if printFiles}}orderItem-files_hasFiles{{else}}orderItem-files_needFiles{{/if}}">
                {{#if printFiles}}
                    <div class="orderItem-files-counter">{{printFiles.length}}</div>
                    <button class="orderItem-files-editble js-openFilesModal">Add / Edit<br />File[s]</button>
                {{else}}
                    <button class="orderItem-files-editble js-openFilesModal">Add File[s]</button>
                {{/if}}
            </td>
        {{/if}}
    {{else}}
        {{#if canPreviewArt}}
            <td class="orderItem-files{{#if artworkPreviewUrl}} orderItem-files_hasThumb{{else}} orderItem-files_viewFiles{{/if}}">
            {{#if artworkPreviewUrl}}
                <div class="orderItem-files-container js-viewItemFiles">
                    <img src="{{artworkPreviewUrl}}" alt="{{productName}} thumbnail image" />
                    <button>View Artwork</button>
                </div>
            {{else}}
                <button class="js-viewItemFiles">View<br />Artwork</button>
            {{/if}}
            </td>
        {{else}}
            {{#if productThumbnailUrl}}
            <td class="orderItem-files orderItem-files_hasThumb">
                <div class="orderItem-files-container">
                    <img src="https://smartpress.imgix.net{{productThumbnailUrl}}?w=200&h=200&fit=crop&auto=format,compress" alt="{{productName}} thumbnail image" />
                </div>
            </td>
            {{else if productImageUrl}}
            <td class="orderItem-files orderItem-files_hasThumb">
                <div class="orderItem-files-container">
                    <img src="https://smartpress.imgix.net{{productImageUrl}}?w=200&h=200&fit=crop&auto=format,compress" alt="{{productName}} thumbnail image" />
                </div>
            </td>
            {{else}}
            <td class="orderItem-files orderItem-files_noFiles">
                <button disabled="disabled">No Files<br />Needed</button>
            </td>
            {{/if}}
        {{/if}}
    {{/if}}
    <td class="orderItem-info">
        <input type="hidden" class="{{productIdWithPrefix}}" value="{{productIdWithPrefix}}">
        {{#if canConfigure}}
            <h3 class="isVisuallyHidden">{{name}}</h3>
            <div class="orderItem-info-name orderItem-info-name_isEditable">
                <label class="orderItem-info-name-label" for="{{id}}"></label>
                <input class="js-editItemName" type="text" value="{{name}}" id="{{id}}"></div>
            {{#unless companionSourceId}}
                <div class="orderItem-info-product">[ {{productName}} ]</div>
            {{/unless}}
        {{else}}
            <h3 class="orderItem-info-name">{{productName}}</h3>
            {{#if stockVariantDetails}}
            <div class="orderItem-info-product">{{stockVariantDetails}}</div>
            {{/if}}
        {{/if}}
        {{#if companionSourceId}}
            <div class="orderItem-info-companionTag">Auto-added with {{#if companionSourceName}}&ldquo;{{companionSourceName}}&rdquo;{{else}}your item{{/if}}</div>
        {{else}}
            {{#unless isStock}}
                <ul class="orderItem-info-actions">
                    {{#if canConfigure}}<li><button class="link link_iconConfig js-configureItem" dialog="dialogConfiguration">Configuration</button></li>{{/if}}
                    {{#if canDuplicate}}<li><button class="link link_iconDuplicate js-duplicateItem" dialog="dialogDuplicateJob">Duplicate</button></li>{{/if}}
                    <li><button class="link link_iconCart js-moveToCart">Move to Cart</button></li>
                </ul>
            {{else}}
                <ul class="orderItem-info-actions">
                    <li><button class="link link_iconCart js-moveToCart">Move to Cart</button></li>
                </ul>
            {{/unless}}
        {{/if}}
    </td>
    <td class="orderItem-qty">
        {{#if stockUnitOfMeasure}}
            <div>{{quantity}}</div>
            <div>{{stockUnitOfMeasure}}</div>
        {{else}}
            {{quantity}}
        {{/if}}
    </td>
    <td class="orderItem-price">
        {{#if isPriceDiscounted}}
            <div style="text-decoration: line-through; opacity: 0.5;">${{displayPrice}}</div>
            <div>${{displayTotalPrice}}</div>
        {{else}}
            ${{displayTotalPrice}}
        {{/if}}
    </td>
    <td class="orderItem-remove">
        <button class="js-removeItem">Remove</button>
    </td>
{{else}}
    <td class="orderItem-files orderItem-files_noFiles">
        <button disabled="disabled">Invalid Item</button>
    </td>
    <td class="orderItem-info">
        {{#if isPOD}}
            {{#if isTemplated}}
                <h3 class="orderItem-info-name">{{productName}}</h3>
            {{else}}
                <h3 class="orderItem-info-name">{{name}}</h3>
                <div class="orderItem-info-product">[ {{productName}} ]</div>
            {{/if}}
        {{/if}}
        {{#if isStock}}
            <h3 class="orderItem-info-name">{{productName}}</h3>
            {{#if stockVariantDetails}}
                <div class="orderItem-info-product">{{stockVariantDetails}}</div>
            {{/if}}
        {{/if}}

        <ul class="orderItem-info-actions">
            <li>This item is no longer valid, please remove from cart.</li>
        </ul>
    </td>
    <td class="orderItem-qty">{{quantity}}</td>
    <td class="orderItem-price">
        {{#if isPriceDiscounted}}
            <div style="text-decoration: line-through; opacity: 0.5;">${{displayPrice}}</div>
            <div>${{displayTotalPrice}}</div>
        {{else}}
            ${{displayTotalPrice}}
        {{/if}}
    </td>
    <td class="orderItem-remove">
        <button class="js-removeItem">Remove</button>
    </td>
{{/if}}

